import { __rest } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';
import styles from './Field.module.css.js';
import { FieldProvider } from '../contexts/FieldProvider.js';

const Field = React.forwardRef((_a, ref) => {
    var { children, className, status } = _a, props = __rest(_a, ["children", "className", "status"]);
    const theme = useTheme();
    return (React.createElement(FieldProvider, { status: status },
        React.createElement(Root, Object.assign({}, props, { theme: theme, ref: ref, className: cn([styles['tend-ui-form-field-root'], className], {
                'tend-ui-form-field-root-has-error': status === 'error',
                'tend-ui-form-field-root-has-warning': status === 'warning',
            }) }), children)));
});
Field.displayName = 'Form.Field';

export { Field };
